import React from "react";
import { MotifLabel, MotifButton } from "@ey-xd/motif-react";
import PropTypes from "prop-types";
import "./errorModal.scss";

const ErrorModal = ({ setName, handleButtonClick, deleteButtonLabel, labelText }) => {
  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      aria-modal="true"
    >
      <div className="error-modal">
        <div className="modal-header">
          <h2 id="error-modal-title">{setName}</h2>
        </div>
        <div className="modal-body">
          <MotifLabel id="error-modal-description">
            {labelText || "Some unknown error occurred"}
          </MotifLabel>
        </div>
        <div className="modal-footer">
          <MotifButton
            onClick={handleButtonClick}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleButtonClick();
              }
            }}
            className="button delete-modal-button"
            aria-label={deleteButtonLabel}
          >
            {deleteButtonLabel}
          </MotifButton>
        </div>
      </div>
    </div>
  );
};

ErrorModal.propTypes = {
  setName: PropTypes.string.isRequired,
  deleteButtonLabel: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  labelText: PropTypes.string,
};

export default ErrorModal;
